import { FC } from 'react';
import { useBotDetectorContext } from '@edikk-edikk/country-frontend';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailContactItemCss from '../../assets/contacts/contact-item.module.scss';

const ContactsPhoneLink: FC = () => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      contactData,
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (!isBot && isDeleted) {
    return (
      <div className={advertDetailContactItemCss.advertDetailContactItem__stub}>
        +
        {Array(contactData.phone.value.length - 1).fill('*').join('')}
      </div>
    );
  }

  return (
    <a
      href={contactData.phone.url}
      target="_blank"
      rel="noopener noreferrer"
      className={advertDetailContactItemCss.advertDetailContactItem__link}
    >
      {contactData.phone.value}
    </a>
  );
};

export { ContactsPhoneLink };
